<template>
  <v-container fluid>
    <v-dialog
      v-model="dialog"
      scrollable
      fullscreen
      transition="dialog-transition"
    >
      <template v-slot:activator="{ attrs }">
        <!-- v-on="on" -->
        <v-btn
          color="teal"
          v-bind="attrs"
          :loading="isloading"
          @click="OpenPayment"
          icon
        >
          <v-icon>fas fa-wallet</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="error white--text">
          Payment Form
          <v-spacer></v-spacer>
          <v-btn class="d-print-none" dark icon @click="dialog = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- {{ Order }} -->
          <v-row class="justify-space-between">
            <v-col cols="4">
              <v-card class="elevation-6">
                <v-simple-table>
                  <thead>
                    <tr class="title teal darken-2 white--text">
                      <td>Description</td>
                      <td>Value</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="font-weight-black ">Order Code:</td>
                      <td class="font-weight-bold ">
                        {{ Order._id }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-black">Supplier:</td>
                      <td class="font-weight-bold">
                        {{ Order.SuppName }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-black">Expected Qty:</td>
                      <td class="font-weight-bold">
                        {{ Order.Total.qty.toLocaleString() }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-black">Expected Price:</td>
                      <td class="font-weight-bold">
                        {{ Order.Total.price.toLocaleString() }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="mx-auto">
                <v-list>
                  <v-subheader class="font-weight-bold"
                    >Payments Orde: {{ Order._id }}</v-subheader
                  >
                  <v-divider></v-divider>
                  <v-list-item-group color="teal">
                    <v-list-item>
                      <v-list-item-content>
                        <DepositeSupp
                          :Title="Order.SuppName"
                          :BaseURL="`${SuppURL}/deposit`"
                          :OtherCost="Order"
                          :ReloadFunc="OpenPayment"
                        ></DepositeSupp>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <DepositeOther
                          Title="Other Cost Payment"
                          :BaseURL="`${SuppURL}/other/deposit`"
                          :OtherCost="Order"
                          :ReloadFunc="OpenPayment"
                        ></DepositeOther>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <CostView
                  :TotalCash="Balance"
                  :Trans="tranList"
                  :load="isloading"
                  :Title="Order._id"
                  :Onfinish="OpenPayment"
                ></CostView>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  components: {
    DepositeSupp: () => import("./SuppCostDeposit.vue"),
    DepositeOther: () => import("./OtherCostDeposit.vue"),
    CostView: () => import("./CostView.vue"),
  },
  props: {
    Order: { type: Object, required: true },
  },
  data() {
    return {
      SuppURL: "/supplier",
      dialog: false,
      isloading: false,
      tranList: [],
      Balance: [],
    };
  },
  methods: {
    OpenPayment() {
      this.isloading = true;
      axios
        .all([this.TranSactions(), this.AvailibleBalance()])
        .then(val => {
          // console.log(val[0]);
          this.tranList = val[0].data;
          this.Balance = val[1].data;
          this.dialog = true;
        })
        .finally(() => {
          this.isloading = false;
        });
    },
    AvailibleBalance() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `stock/Ontheway/balance`,
        query: {
          Reason: this.Order._id,
        },
      });
    },
    TranSactions() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `stock/Ontheway/transactions`,
        query: {
          Reason: this.Order._id,
        },
      });
    },
  },
  mounted() {
    // this.TranSactions().then(val => {
    //   console.log(val);
    // });
  },
};
</script>
